export default {
  permissions: [],
}
